/**
 * How often a surface re-reads while work is in flight.
 *
 * One number for everything that follows live work — the board, the overview,
 * a task's results — so "the board's cadence" is a constant and not three
 * literals that happen to agree. Two seconds is fast enough that a card's
 * state, a summary and an attention row change within one glance of each
 * other, and slow enough that an open board is not a load on the service
 * (constitution §6: polling is a stated policy, never blanket refetching).
 */
export const LIVE_POLL_MS = 2000;
